export const Constant = {
  MIN_OPACITY: 0,
  MAX_OPACITY: 1,

  DEFAULT_DURATION_IN_MS: 500,
  INITIAL_POSITION_Y: -100,
  FINAL_POSITION_Y: 0,
};
